import { createFileRoute } from "@tanstack/react-router";
import DepressionInCollege from "@/pages/articles/DepressionInCollege";
export const Route = createFileRoute("/depression-in-college")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression In College | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "College student depression is common and treatable. Learn about TMS, SAINT TMS, and supportive care for students in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Depression In College | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "College student depression is common and treatable. Learn about TMS, SAINT TMS, and supportive care for students in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/depression-in-college",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-in-college",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionInCollege />;
}
